<template>
    <div class="grid">
        <div class="col-12">
            <div class="col-12 sticky">
                <div id="custom_card" class="card">
                    <div class="grid justify-content-between">
                        <div class="col-12 md:col-6">
                            <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
                            >
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("asset_depreciationschedulereport") }}
                            </p>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
                                <Button @click="print" class="p-button-rounded p-button-danger" icon="pi pi-file-pdf" v-tooltip.bottom="$t('pdf')"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                
                <div class="container Application_container mt-4">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-12 md:col-2">
                            <span class="p-float-label">
                            <Dropdown
                                id="status"
                                v-model="status_dropdownItem"
                                :options="asset_status_master"
                                optionLabel="name"
                                filter
                                @change="GetReport()"
                            >
                            </Dropdown>
                         
                            <label>{{ $t("search_year") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3">
                            <Button
                                        iconPos="right"
                                        :label="$t('Calculate Depreciation(Yearly)')"
                                        v-tooltip.bottom="$t('Calculate Depreciation(Yearly)')"
                                        @click="calculate"
                                        size="small"
                                        style=""
                                    />                        
                        </div>
                    </div>
                </div>
                <!-- Printable Section -->
                <div id="printMe">
                    <div class="container Application_container mt-4 text-center">
                        <b style="font-size: 2rem;">{{ $t("Labour_Commissionerate") }}</b>
                        <p class="mt-4">
                            {{ $t("asset_depreciation_schedule_report") }} : <b>{{ year }}</b>
                        </p>
                    </div>
                    <div class="container Application_container mt-4 text-left">
                        <p>{{ $t("report_date") }} : {{ getCurrentDate() }}</p>
                    </div>
                    <!-- Table Wrapper -->
                    <div class="print-wrapper">
                        <table class="table table-bordered" style="border: 1px solid black; width: 100%;">
                            <thead>
                                <tr>
                                    <th><strong>{{ $t("asset_code") }}</strong></th>
                                    <th><strong>{{ $t("asset_discription") }}</strong></th>
                                    <th><strong>{{ $t("original_cost") }}</strong></th>
                                    <th><strong>{{ $t("depreciation_method") }}</strong></th>
                                    <th><strong>{{ $t("useful_life") }}</strong></th>
                                    <th><strong>{{ $t("depreciation_start_date") }}</strong></th>
                                    <th><strong>{{ $t("current_year_depreciation") }}</strong></th>
                                    <th><strong>{{ $t("accumulated_depreciation") }}</strong></th>
                                    <th><strong>{{ $t("net_book_value") }}</strong></th>
                                    <th><strong>{{ $t("remaining_useful_life") }}</strong></th>
                                </tr>
                            </thead>
                            <tbody v-for="item in rows" :key="item.id">
                                <tr>
                                    <td>{{ item.asset_code }}</td>
                                    <td>{{ item.asset_discription }}</td>
                                    <td>{{ item.original_cost }}</td>
                                    <td>{{ item.depreciation_method_name }}</td>
                                    <td>{{ item.useful_life }}</td>
                                    <td>{{ dateFormatDMY(item.depreciation_start_date) }}</td>
                                    <td>{{ item.current_year_depreciation_amt }}</td>
                                    <td>{{ item.accumulated_depreciation }}</td>
                                    <td>{{ item.net_book_value }}</td>
                                    <td>{{ item.remaining_useful_life }}</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td><strong>{{ $t("total") }}</strong></td>
                                    <td></td>
                                    <td><strong>{{ total_original_cost }}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>{{ total_current_year_depreciation_amt }}</strong></td>
                                    <td><strong>{{ total_accumulated_depreciation }}</strong></td>
                                    <td>{{ total_net_book_value }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '25vw' }"
      :header="$t('Calculate Yearly Depreciation')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12" style="margin-top: 3%;">
                            <span class="p-float-label">
                            <Dropdown
                                id="status"
                                v-model="cal_status_dropdownItem"
                                :options="asset_status_master"
                                optionLabel="name"
                                filter
                
                            >
                            </Dropdown>
                         
                            <label>{{ $t("search_year") }}</label>
                            </span>
                        </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('Calculate')"
          @click="cal_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>

            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: "MahatakrarDepreciationHistoryAssetWise",
    data() {
        return {
            year:'',
            total_original_cost: "0.00",
            total_current_year_depreciation_amt: "0.00",
            total_accumulated_depreciation: "0.00",
            total_net_book_value: "0.00",
            productDialog:false,
            rows: [],
            asset_status_master: [],
            status_dropdownItem: null,
            cal_status_dropdownItem:null,
        };
    },
    async mounted() {
        this.asset_status_master = this.getPreviousTenFinancialYears();
    },
    methods: {
        cal_event()
        {   
             var data = {
                "client_id"     : localStorage.getItem("client_id"),
                "fa_year_from"  : this.status_dropdownItem?.value,
                "user_id"       : localStorage.getItem("id"),
                "lang"          : this.$i18n.locale,
            };
            var promise = apis.calculateYearlyDepreciation(data);
            promise.then((response) => {
                if (response.data.status == true) 
                {
                    this.$toast.add({
                    severity: "success",
                    summary: "success",
                    detail: response.data.message,
                    life: 3000,
                    });
                    this.status_dropdownItem = this.cal_status_dropdownItem;
                    this.GetReport();
                    this.productDialog = false;
                    return false;
                }
                else
                {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: response.data.message,
                        life: 3000,
                    });
                }
                    
            });
           
        },
        calculate() 
        {
            this.cal_status_dropdownItem=null;
            this.productDialog = true;
            
        },
        getPreviousTenFinancialYears() 
        {
            const financialYears = [];
            const currentMonth = new Date().getMonth(); // 0-indexed (0 for Jan, 11 for Dec)
            const currentYear = new Date().getFullYear();

            let startYearOfCurrentFY;

            // Determine the starting year of the current financial year
            // If current month is Jan, Feb, or Mar, the FY started in April of the previous calendar year.
            // Otherwise (Apr-Dec), the FY started in April of the current calendar year.
            if (currentMonth >= 0 && currentMonth <= 2) { // January, February, March
                startYearOfCurrentFY = currentYear - 1;
            } else { // April to December
                startYearOfCurrentFY = currentYear;
            }

            for (let i = 0; i < 10; i++) {
                const startYear = startYearOfCurrentFY - i;
                const endYear = startYear + 1;
                financialYears.push({
                name: `${startYear}-${endYear}`,
                value: `${startYear}`
                });
            }

            return financialYears;
        },
        getCurrentDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
            const year = today.getFullYear();
            return `${day}-${month}-${year}`;
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year;
                    }
                }
            } else {
                return "";
            }
        },
        back() {
            this.$router.push({
                name: "asset",
            });
        },
        async print() {
            // Pass the element id here
            await this.$htmlToPaper('printMe');
        },
        GetReport() {
            this.rows =[];
                    this.total_original_cost='0.00';
                    this.total_current_book_value='0.00';
                        this.year='';
            
            var data = {
                client_id: localStorage.getItem("client_id"),
               year: this.status_dropdownItem?.value
            };
            var promise = apis.get_depreciation_schedule_report(data);
            promise.then((response) => {
                if (response.data.status == true && response.data.data.length > 0) {
                    this.year = this.status_dropdownItem?.name;
                    this.rows = response.data.data;
                    this.total_original_cost = response.data.total.total_original_cost;
                    this.total_current_year_depreciation_amt =
                        response.data.total.total_current_year_depreciation_amt;
                    this.total_accumulated_depreciation =
                        response.data.total.total_accumulated_depreciation;
                    this.total_net_book_value = response.data.total.total_net_book_value;
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error!!!",
                        detail: "Details Not Found",
                        life: 3000,
                    });
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.bold {
    font-weight: bold;
    font-size: 14px;
    color: #000;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

.table td {
    padding: 5px 10px;
}

.head {
    text-align: left;
}

/* Wrapper for scroll in screen view */
.print-wrapper {
    overflow: auto;
    max-height: 400px;
}

/* PRINT-SPECIFIC STYLES */
@media print {

    /* Remove scrollbar and allow full content */
    .print-wrapper {
        overflow: visible !important;
        max-height: none !important;
    }

    /* Make table fit page width */
    table {
        width: 100% !important;
        table-layout: auto !important;
        word-wrap: break-word;
    }

    th,
    td {
        white-space: normal !important;
        word-break: break-word;
    }

    .p-button-danger,
    .p-button-rounded {
        display: none !important;
    }

    @page {
        size: landscape;
        /* Optional: wider page for table */
        margin: 10mm;
    }
}
</style>
